export interface ParsedResponse {
  data: unknown;
  isJson: boolean;
  preview?: string;
}

export function parseResponseText(text: string, contentType: string | null): ParsedResponse {
  if (!text) return { data: undefined, isJson: true };
  const looksJson = /\bjson\b/i.test(contentType ?? '') || /^[\s\r\n]*[\[{]/.test(text);
  if (looksJson) {
    try {
      return { data: JSON.parse(text) as unknown, isJson: true };
    } catch {
      // Fall through to a text preview so callers can report the real HTTP layer.
    }
  }
  return {
    data: text,
    isJson: false,
    preview: text.replace(/\s+/g, ' ').trim().slice(0, 160),
  };
}

export function staticApkFetchError(input: string, status: number, parsed: ParsedResponse): Error & { status?: number; data?: unknown } {
  const msg = nonJsonHint(input, status, parsed) ?? jsonErrorMessage(status, parsed.data);
  const err = new Error(msg) as Error & { status?: number; data?: unknown };
  err.status = status;
  err.data = parsed.data;
  return err;
}

export function expectedJsonError(input: string, parsed: ParsedResponse): Error & { data?: unknown } {
  const hint = nonJsonHint(input, 200, parsed);
  const err = new Error(hint ?? 'APK 分析 API 返回了非 JSON 响应') as Error & { data?: unknown };
  err.data = parsed.data;
  return err;
}

function nonJsonHint(input: string, status: number, parsed: ParsedResponse): string | undefined {
  if (parsed.isJson) return undefined;
  const preview = parsed.preview ?? '';
  if (/^<!doctype html|^<html/i.test(preview)) {
    return `HTTP ${status}: APK 分析 API 返回了 HTML，通常表示后端服务未重启到最新代码，或 /api/static-analysis/apk 路由未命中。路径：${input}`;
  }
  return `HTTP ${status}: APK 分析 API 返回了非 JSON 响应：${preview || '(empty)'}`;
}

function jsonErrorMessage(status: number, data: unknown): string {
  const obj = typeof data === 'object' && data !== null ? data as { error?: unknown; detail?: unknown } : undefined;
  if (typeof obj?.error === 'string') {
    return `${obj.error}${typeof obj.detail === 'string' ? `: ${obj.detail}` : ''}`;
  }
  if (typeof obj?.error === 'object' && obj.error !== null) {
    const err = obj.error as { code?: unknown; message?: unknown };
    if (typeof err.message === 'string') {
      return `${typeof err.code === 'string' ? `${err.code}: ` : ''}${err.message}`;
    }
  }
  return `HTTP ${status}`;
}
